/**
 * Base site URL for canonical links and OG URLs. No trailing slash.
 * Set NEXT_PUBLIC_SITE_URL in production (e.g. https://www.identio.fi).
 */
export function getSiteUrl() {
  return (process.env.NEXT_PUBLIC_SITE_URL || 'https://identio.fi').replace(
    /\/$/,
    ''
  );
}

/**
 * Build absolute canonical URL for a path.
 * @param {string} path - Path with or without leading slash (e.g. '/careers' or '/en/careers').
 * @returns {string} Full URL (e.g. 'https://www.identio.fi/careers').
 */
export function getCanonicalUrl(path) {
  const base = getSiteUrl();
  if (!path || path === '/') return `${base}/`;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

/**
 * Build hreflang alternate entries for the SEO component.
 * Returns fi, en, and x-default (pointing to fi) alternates.
 * @param {string} fiPath - Finnish page path (e.g. '/palvelut')
 * @param {string|null} enPath - English page path (e.g. '/services'), or null if no EN version
 * @returns {Array<{hreflang: string, href: string}>}
 */
export function buildHreflangTags(fiPath, enPath) {
  const fiUrl = getCanonicalUrl(fiPath);
  const tags = [
    { hreflang: 'fi', href: fiUrl },
    { hreflang: 'x-default', href: fiUrl },
  ];
  if (enPath) {
    tags.push({ hreflang: 'en', href: getCanonicalUrl(enPath) });
  }
  return tags;
}
